export function getDataJWT(){
	if (window.localStorage.getItem('token_codesii')) {
	  var base64Url = window.localStorage.getItem('token_codesii').split('.')[1];
	  var base64 = base64Url.replace('-', '+').replace('_', '/');
	  return JSON.parse(window.atob(base64));
	}else{
		return false;
	}
}